import { clamp, getDistances, getRandom } from "tsparticles-engine";
export function applyDistance(particle) {
  var initialPosition = particle.initialPosition,
      _getDistances = getDistances(initialPosition, particle.position),
      dx = _getDistances.dx,
      dy = _getDistances.dy,
      dxFixed = Math.abs(dx),
      dyFixed = Math.abs(dy),
      maxDistance = particle.retina.maxDistance,
      hDistance = maxDistance.horizontal,
      vDistance = maxDistance.vertical;

  if (!hDistance && !vDistance) {
    return;
  }

  if ((hDistance && dxFixed >= hDistance || vDistance && dyFixed >= vDistance) && !particle.misplaced) {
    particle.misplaced = !!hDistance && dxFixed > hDistance || !!vDistance && dyFixed > vDistance;

    if (hDistance) {
      particle.velocity.x = particle.velocity.y / 2 - particle.velocity.x;
    }

    if (vDistance) {
      particle.velocity.y = particle.velocity.x / 2 - particle.velocity.y;
    }
  } else if ((!hDistance || dxFixed < hDistance) && (!vDistance || dyFixed < vDistance) && particle.misplaced) {
    particle.misplaced = false;
  } else if (particle.misplaced) {
    var pos = particle.position,
        vel = particle.velocity;

    if (hDistance && (pos.x < initialPosition.x && vel.x < 0 || pos.x > initialPosition.x && vel.x > 0)) {
      vel.x *= -getRandom();
    }

    if (vDistance && (pos.y < initialPosition.y && vel.y < 0 || pos.y > initialPosition.y && vel.y > 0)) {
      vel.y *= -getRandom();
    }
  }
}
export function move(particle, moveOptions, moveSpeed, maxSpeed, moveDrift, delta) {
  applyPath(particle, delta);
  var gravityOptions = particle.gravity,
      gravityFactor = gravityOptions !== null && gravityOptions !== void 0 && gravityOptions.enable && gravityOptions.inverse ? -1 : 1;

  if (moveDrift && moveSpeed) {
    particle.velocity.x += moveDrift * delta.factor / (60 * moveSpeed);
  }

  if (gravityOptions !== null && gravityOptions !== void 0 && gravityOptions.enable && moveSpeed) {
    particle.velocity.y += gravityFactor * (gravityOptions.acceleration * delta.factor) / (60 * moveSpeed);
  }

  var decay = particle.moveDecay;
  particle.velocity.multTo(decay);
  var velocity = particle.velocity.mult(moveSpeed);

  if (gravityOptions !== null && gravityOptions !== void 0 && gravityOptions.enable && maxSpeed > 0 && (!gravityOptions.inverse && velocity.y >= 0 && velocity.y >= maxSpeed || gravityOptions.inverse && velocity.y <= 0 && velocity.y <= -maxSpeed)) {
    velocity.y = gravityFactor * maxSpeed;

    if (moveSpeed) {
      particle.velocity.y = velocity.y / moveSpeed;
    }
  }

  var zIndexOptions = particle.options.zIndex,
      zVelocityFactor = Math.pow(1 - particle.zIndexFactor, zIndexOptions.velocityRate);
  velocity.multTo(zVelocityFactor);
  var position = particle.position;
  position.addTo(velocity);

  if (moveOptions.vibrate) {
    position.x += Math.sin(position.x * Math.cos(position.y));
    position.y += Math.cos(position.y * Math.sin(position.x));
  }
}
export function spin(particle, moveSpeed) {
  var container = particle.container;

  if (!particle.spin) {
    return;
  }

  var updateFunc = {
    x: particle.spin.direction === "clockwise" ? Math.cos : Math.sin,
    y: particle.spin.direction === "clockwise" ? Math.sin : Math.cos
  };
  particle.position.x = particle.spin.center.x + particle.spin.radius * updateFunc.x(particle.spin.angle);
  particle.position.y = particle.spin.center.y + particle.spin.radius * updateFunc.y(particle.spin.angle);
  particle.spin.radius += particle.spin.acceleration;
  var maxCanvasSize = Math.max(container.canvas.size.width, container.canvas.size.height);

  if (particle.spin.radius > maxCanvasSize / 2) {
    particle.spin.radius = maxCanvasSize / 2;
    particle.spin.acceleration *= -1;
  } else if (particle.spin.radius < 0) {
    particle.spin.radius = 0;
    particle.spin.acceleration *= -1;
  }

  particle.spin.angle += moveSpeed / 100 * (1 - particle.spin.radius / maxCanvasSize);
}
export function applyPath(particle, delta) {
  var _particle$pathGenerat;

  var particlesOptions = particle.options,
      pathOptions = particlesOptions.move.path,
      pathEnabled = pathOptions.enable;

  if (!pathEnabled) {
    return;
  }

  if (particle.lastPathTime <= particle.pathDelay) {
    particle.lastPathTime += delta.value;
    return;
  }

  var path = (_particle$pathGenerat = particle.pathGenerator) === null || _particle$pathGenerat === void 0 ? void 0 : _particle$pathGenerat.generate(particle, delta);

  if (path) {
    particle.velocity.addTo(path);
  }

  if (pathOptions.clamp) {
    particle.velocity.x = clamp(particle.velocity.x, -1, 1);
    particle.velocity.y = clamp(particle.velocity.y, -1, 1);
  }

  particle.lastPathTime -= particle.pathDelay;
}
export function getProximitySpeedFactor(particle) {
  return particle.slow.inRange ? particle.slow.factor : 1;
}